// Six editable roles; all derived CSS values are computed from validated opaque HEX colors.
export const DEFAULT_PALETTE = Object.freeze({ primary: '#12b423', secondary: '#0294d7', background: '#ffffff', surface: '#ffffff', text: '#000000', dark: '#020702' })
const hex = value => typeof value === 'string' && /^#[\da-f]{6}$/i.test(value)
const rgb = value => [1, 3, 5].map(i => parseInt(value.slice(i, i + 2), 16))
const encode = values => '#' + values.map(v => Math.round(v).toString(16).padStart(2, '0')).join('')
const mix = (a, b, weight) => encode(rgb(a).map((v, i) => v * (1 - weight) + rgb(b)[i] * weight))
export function normalizePalette(value) {
  const palette = { ...DEFAULT_PALETTE, ...value }
  if (!Object.keys(DEFAULT_PALETTE).every(key => hex(palette[key]))) throw new Error('Некоректна палітра сайту')
  return Object.fromEntries(Object.keys(DEFAULT_PALETTE).map(key => [key, palette[key].toLowerCase()]))
}
export function contrastText(color) {
  const linear = rgb(color).map(v => { v /= 255; return v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4 })
  return linear.reduce((sum, v, i) => sum + v * [0.2126, 0.7152, 0.0722][i], 0) > 0.179 ? '#000000' : '#ffffff'
}
export function paletteVariables(value) {
  const p = normalizePalette(value)
  const values = { ...p, 'on-dark': contrastText(p.dark), 'on-surface': p.text,
    'text-muted': mix(p.text, p.surface, 0.23), border: mix(p.surface, p.text, 0.17),
    'surface-muted': mix(mix(p.surface, p.background, 0.5), p.text, 0.04), 'dark-raised': mix(p.dark, '#ffffff', 0.10),
    'text-rgb': rgb(p.text).join(', '), 'shadow-rgb': rgb(p.dark).join(', ') }
  for (const role of ['primary', 'secondary']) {
    values[`${role}-rgb`] = rgb(p[role]).join(', ')
    values[`${role}-hover`] = mix(p[role], '#000000', 0.18)
    values[`${role}-ink`] = mix(p[role], '#000000', 0.58)
    values[`${role}-soft`] = mix(p.surface, p[role], 0.08)
    values[`${role}-muted`] = mix(p.surface, p[role], 0.26)
    values[`on-${role}-ink`] = contrastText(values[`${role}-ink`])
    values[`on-${role}`] = contrastText(p[role])
    values[`on-${role}-hover`] = contrastText(values[`${role}-hover`])
  }
  return Object.fromEntries(Object.entries(values).map(([key, value]) => [`--corp-${key}`, value]))
}
export function applyPalette(value) {
  const variables = paletteVariables(value)
  if (typeof document !== 'undefined') {
    for (const [name, color] of Object.entries(variables)) document.documentElement.style.setProperty(name, color)
  }
  return variables
}
